
/**
 * Internal dependencies
 */
import {
    SUPPORT_PLANS_RECEIVE,
    SUPPORT_PLANS_REQUEST,
    SUPPORT_PLANS_REQUEST_SUCCESS,
    SUPPORT_PLANS_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import { getAllSupportPlans, requestingSupportPlans } from './selectors';

/**
 * [description]
 * 
 * @param  {Function} includeSupport [description]
 * @return {[type]}                  [description]
 */
export const requestSupportPlans = () => (dispatch) => {
    dispatch({
        type: SUPPORT_PLANS_REQUEST
    });
    return cscom.supportPlan().list()
        .then(supportPlans => {
            dispatch({ type: SUPPORT_PLANS_REQUEST_SUCCESS });
            dispatch({ type: SUPPORT_PLANS_RECEIVE, payload: { items: supportPlans } });
            return supportPlans;
        })
        .catch((error) => {
            dispatch({ type: SUPPORT_PLANS_REQUEST_FAILURE, error });
        });
}

/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestPlansIfNotRequested = (...props) => async (dispatch, getState) => {
	
	const plans = getAllSupportPlans(getState());
	const requesting = requestingSupportPlans(getState());

	if (plans.length == 0 && requesting == false) {
		return dispatch(requestSupportPlans(...props))
	}

	return plans;
}